import { Helmet } from "react-helmet";
import FullGallery from "../components/Sections/FullGallery";

const Gallery = () => {
    return (
        <div style={{ paddingTop: "99px", minHeight: 'calc(100vh - 100px)'}}>
            <Helmet>
                <title>Gallery</title>
            </Helmet>
            <div className="text-primary-blue text-5xl font-extralight text-center pt-12 font-poppins">
                Gallery
            </div>
            <FullGallery variant = {1}/>
        </div>
    );
};

export default Gallery;
